import { IconMenu2, IconMoon, IconSun } from '@tabler/icons-react';

import CenterSwitcher from 'components/layout/CenterSwitcher';
import { Breadcrumb } from 'components/layout/PageHeader';
import MessagesButton from 'components/chat/MessagesButton';
import NotificationBell from 'components/notifications/NotificationBell';
import UserMenu from 'components/layout/UserMenu';
import { useTheme } from 'contexts/ThemeContext';
import { useModulePermission } from 'hooks/useModulePermission';

/** Sticky top bar: mobile menu, breadcrumb, theme toggle, and the user menu. */
export function Header({ onMenuClick, crumb, title }) {
  const { isDark, toggleTheme } = useTheme();
  // Chat and Notifications are ordinary modules with their own Role Editor
  // rows and their own gated routers. Their entry points live up here rather
  // than in the sidebar, so the nav filter never covered them — the icons
  // stayed put while every request behind them was refused.
  const { canRead: canChat } = useModulePermission('chat');
  const { canRead: canNotify } = useModulePermission('notifications');

  return (
    <header className="sticky top-0 z-20 flex h-[68px] flex-none items-center gap-3 border-b border-hair bg-paper px-4 sm:px-6 lg:h-[76px] lg:px-10">
      <button
        type="button"
        onClick={onMenuClick}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-slate hover:bg-black/[0.06] lg:hidden"
        aria-label="Open menu"
      >
        <IconMenu2 className="h-6 w-6" />
      </button>

      <div className="min-w-0 flex-1">
        <Breadcrumb crumb={crumb} title={title} />
      </div>

      <div className="ml-auto flex items-center gap-1.5 sm:gap-3.5">
        <button
          type="button"
          onClick={toggleTheme}
          title="Toggle theme"
          aria-label="Toggle light/dark theme"
          className="flex h-[38px] w-[38px] items-center justify-center rounded-full text-slate transition-colors hover:bg-black/[0.06]"
        >
          {isDark ? <IconSun className="h-5 w-5" /> : <IconMoon className="h-5 w-5" />}
        </button>
        {canChat && <MessagesButton />}
        {canNotify && <NotificationBell />}
        <CenterSwitcher />
        <UserMenu />
      </div>
    </header>
  );
}

export default Header;
